import React, { useEffect, useState } from "react";
import { Bell, AlertCircle, Calendar, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Badge } from "./ui/badge";

const TYPE_META = {
  task_overdue: { icon: AlertCircle, cls: "text-rose-500", label: "Scaduta" },
  task_due_soon: { icon: Clock, cls: "text-amber-500", label: "In scadenza" },
  appointment_today: { icon: Calendar, cls: "text-violet-500", label: "Appuntamento" },
};

export default function NotificationsBell() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then(({ data }) => setItems(data.items || [])).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  const count = items.length;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative w-9 h-9 rounded-md hover:bg-muted flex items-center justify-center transition-colors" aria-label="Notifiche" data-testid="notifications-bell">
          <Bell className="w-4 h-4" />
          {count > 0 && <span className="absolute top-1 right-1 min-w-[16px] h-4 px-1 rounded-full bg-rose-500 text-white text-[9px] font-bold flex items-center justify-center tabular-nums">{count > 9 ? "9+" : count}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0">
        <div className="p-3 border-b border-border/60 flex items-center justify-between">
          <h3 className="font-heading font-medium text-sm">Notifiche</h3>
          <Badge variant="secondary" className="tabular-nums">{count}</Badge>
        </div>
        <div className="max-h-96 overflow-y-auto scrollbar-thin">
          {items.length === 0 ? (
            <p className="text-xs text-muted-foreground text-center py-8">Tutto in ordine. Nessuna notifica.</p>
          ) : items.map((n) => {
            const meta = TYPE_META[n.type] || { icon: Bell, cls: "text-muted-foreground", label: "" };
            const Icon = meta.icon;
            const link = n.entity_type === "task" && n.property_id ? `/properties/${n.property_id}` : n.entity_type === "appointment" ? "/calendar" : "/tasks";
            return (
              <Link key={n.id} to={link} className="flex items-start gap-3 p-3 border-b border-border/60 hover:bg-muted/40 last:border-b-0" data-testid={`notif-${n.id}`}>
                <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${meta.cls}`} />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium truncate">{n.title}</div>
                  <div className="text-[11px] text-muted-foreground">
                    {meta.label}{n.due_date ? ` · ${new Date(n.due_date).toLocaleString("it-IT")}` : ""}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
}
